import React, { useEffect, useState, useCallback } from "react";
import "./Product.css";
import { Col } from "react-bootstrap";
import rating from "../../assets/images/rating.png";
import Tag from "../tag/Tag";
import useStore from "../../app/store";
import { useNavigate } from "react-router-dom";

function Product(props) {
    const { cartArr, removeQuantity, addQuantity, addCart } = useStore((state) => ({
        cartArr: state.cartArr,
        removeQuantity: state.removeQuantity,
        addQuantity: state.addQuantity,
        addCart: state.addCart,
    }));

    // const [counter, setCounter] = useState(1);
    const [addToCard, setAddToCart] = useState(false);
    const [addCartBtn, setAddCartBtn] = useState(true);
    const [showImage, setShowImage] = useState(false);

    const singleQuantity = cartArr.map((cart) => {
        if (props.id == cart.id){
            return cart.quantity;
        }
    });

    const navigate = useNavigate();
    const catDetailHandler = (e) => {
        e.preventDefault();
        navigate("/category-detail");
    };

    const incrementHandler = (name) => {
        if ("firstAdd" == name) {
            addCart({
                id: props.id,
                image: props.img,
                title: props.title,
                price: props.price,
                quantity: props.quantity,
            });
            setShowImage(true);
            // let positionEl = document.querySelector(".animation-img").getBoundingClientRect();
            // console.log(positionEl);
        } else {
            // setCounter(counter + 1);
            addQuantity(props.id);
        }
    };
    const decrementHandler = () => {
        // setCounter(counter - 1);
        removeQuantity(props.id);
    };

    const buttonStateHandler = (propId) => {
        return cartArr.map((cart) => {
            if (cart.id == propId) {
                if (cart.quantity < 1) {
                    setAddCartBtn(true);
                    setAddToCart(false);
                    removeQuantity(cart.id);
                    setShowImage(false);
                } else if (cart.quantity > 0) {
                    setAddCartBtn(false);
                    setAddToCart(true);
                }
            }
        });
    };

    // useEffect(() => {
    //     if (showImage === true) {
    //         setTimeout(() => {
    //             document.querySelector(".animation-img").classList.add("go-cart");
    //         }, 1000);
    //     }
    // }, [showImage]);

    useEffect(() => {
        buttonStateHandler(props.id);
    }, [cartArr]);

    return (
        <Col md={3} lg={2}>
            <React.Fragment key={props.id}>
                <div className="product__wrapper">
                    {props.tag && <Tag value={props.tag.value} bg={props.tag.bg} />}
                    <div className="product__image" onClick={catDetailHandler}>
                        <img src={props.img} alt="product" className="img-fluid" />
                        {showImage && (
                            <img
                                src={props.img}
                                alt="product"
                                className="img-fluid animation-img shake go-cart"
                            />
                        )}
                    </div>
                    <div className="product__info">
                        <img src={rating} alt="rating stars" />
                        <p className="product__name">{props.title}</p>
                        <p className="product__price">PKR {props.price}</p>
                        <div className="product__addToCart-button">
                            {addCartBtn && (
                                <button onClick={() => incrementHandler("firstAdd")}>
                                    <span className="flex-1 addText">Add</span>
                                    <span className="product__cartIcon">
                                        <svg
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.12182 5.12891H1.1123M5.12182 1.12891V5.12891V1.12891ZM5.12182 5.12891V9.12891V5.12891ZM5.12182 5.12891H9.13134H5.12182Z"
                                                stroke="black"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                </button>
                            )}

                            {addToCard && (
                                <button>
                                    <span
                                        className="product__cartIcon icon-minus"
                                        onClick={decrementHandler}
                                    >
                                        <svg
                                            width="10"
                                            height="2"
                                            viewBox="0 0 10 2"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.02953 1.05469H5.02001H1.0105"
                                                stroke="black"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                    <span className="flex-1 addText">{singleQuantity}</span>
                                    <span
                                        className="product__cartIcon"
                                        onClick={() => incrementHandler("moreAdd")}
                                    >
                                        <svg
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.12182 5.12891H1.1123M5.12182 1.12891V5.12891V1.12891ZM5.12182 5.12891V9.12891V5.12891ZM5.12182 5.12891H9.13134H5.12182Z"
                                                stroke="black"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                </button>
                            )}
                            <button className="mt-3">
                                <span className="flex-1 addText">Share</span>
                                <span className="product__whatsapp-icon">
                                    <svg
                                        width="25"
                                        height="25"
                                        viewBox="0 0 25 25"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.97567 18.5487L8.69967 18.9717C9.92061 19.6838 11.3093 20.0576 12.7227 20.0547C14.3049 20.0547 15.8516 19.5855 17.1672 18.7064C18.4828 17.8274 19.5082 16.578 20.1137 15.1162C20.7192 13.6543 20.8776 12.0458 20.569 10.494C20.2603 8.94212 19.4983 7.51665 18.3795 6.39783C17.2607 5.27901 15.8352 4.51709 14.2834 4.20841C12.7315 3.89972 11.123 4.05815 9.6612 4.66365C8.19939 5.26915 6.94996 6.29453 6.07091 7.61013C5.19186 8.92572 4.72267 10.4724 4.72267 12.0547C4.72267 13.4907 5.09967 14.8677 5.80667 16.0787L6.22867 16.8027L5.57567 19.2037L7.97567 18.5487ZM2.72667 22.0547L4.07867 17.0867C3.18781 15.5595 2.71977 13.8227 2.72267 12.0547C2.72267 6.53169 7.19967 2.05469 12.7227 2.05469C18.2457 2.05469 22.7227 6.53169 22.7227 12.0547C22.7227 17.5777 18.2457 22.0547 12.7227 22.0547C10.9554 22.0575 9.21933 21.5899 7.69267 20.6997L2.72667 22.0547ZM9.11367 7.36269C9.24767 7.35269 9.38267 7.35269 9.51667 7.35869C9.57067 7.36269 9.62467 7.36869 9.67867 7.37469C9.83767 7.39269 10.0127 7.48969 10.0717 7.62369C10.3697 8.29969 10.6597 8.98069 10.9397 9.66369C11.0017 9.81569 10.9647 10.0107 10.8467 10.2007C10.7655 10.3292 10.6777 10.4533 10.5837 10.5727C10.4707 10.7177 10.2277 10.9837 10.2277 10.9837C10.2277 10.9837 10.1287 11.1017 10.1667 11.2487C10.1807 11.3047 10.2267 11.3857 10.2687 11.4537L10.3277 11.5487C10.5837 11.9757 10.9277 12.4087 11.3477 12.8167C11.4677 12.9327 11.5847 13.0517 11.7107 13.1627C12.1787 13.5757 12.7087 13.9127 13.2807 14.1627L13.2857 14.1647C13.3707 14.2017 13.4137 14.2217 13.5377 14.2747C13.5997 14.3007 13.6637 14.3237 13.7287 14.3407C13.7958 14.3578 13.8666 14.3546 13.9319 14.3314C13.9973 14.3083 14.0542 14.2663 14.0957 14.2107C14.8197 13.3337 14.8857 13.2767 14.8917 13.2767V13.2787C14.942 13.2318 15.0017 13.1962 15.0669 13.1743C15.1321 13.1524 15.2013 13.1447 15.2697 13.1517C15.3297 13.1557 15.3907 13.1667 15.4467 13.1917C15.9777 13.4347 16.8467 13.8137 16.8467 13.8137L17.4287 14.0747C17.5267 14.1217 17.6157 14.2327 17.6187 14.3397C17.6227 14.4067 17.6287 14.5147 17.6057 14.7127C17.5737 14.9717 17.4957 15.2827 17.4177 15.4457C17.3643 15.5569 17.2934 15.6589 17.2077 15.7477C17.1068 15.8536 16.9963 15.95 16.8777 16.0357C16.8366 16.0665 16.795 16.0966 16.7527 16.1257C16.6283 16.2046 16.5005 16.278 16.3697 16.3457C16.1122 16.4824 15.8278 16.561 15.5367 16.5757C15.3517 16.5857 15.1667 16.5997 14.9807 16.5897C14.9727 16.5897 14.4127 16.5027 14.4127 16.5027C12.9909 16.1287 11.6761 15.4282 10.5727 14.4567C10.3467 14.2577 10.1377 14.0437 9.92367 13.8307C9.03367 12.9457 8.36167 11.9907 7.95367 11.0887C7.74484 10.646 7.63204 10.1641 7.62267 9.67469C7.61855 9.06754 7.81702 8.47635 8.18667 7.99469C8.25967 7.90069 8.32867 7.80269 8.44767 7.68969C8.57467 7.56969 8.65467 7.50569 8.74167 7.46169C8.85734 7.40372 8.98353 7.36971 9.11267 7.36169L9.11367 7.36269Z"
                                            fill="#2DB000"
                                        />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        </Col>
    );
}

export default Product;
